// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2QSA5","list":"PatternAutocomplete_list__nbQro"};